import { AbstractEntity } from "./AbstractEntity";
export default class ErrorLog extends AbstractEntity {
    error;
    constructor(error) {
        super();
        this.error = error;
    }
}
//# sourceMappingURL=ErrorLogData.js.map